import React, { useState, useRef, useEffect } from 'react';
import useTableScroll from "../../../components/useTableScrollcesar";
import { verificarSeleccion, verificarSeleccionRet } from '../../../util/OperacionPago';
import axios from 'axios';
import moment from 'moment';
import { formatMoneda } from '../../../util/varios';
import { RegistrarPago } from './modalRegistrarPago';
import { Mensaje, MensajeSiNo } from '../../../components/mensajes2';

import { Dimmer } from '../../../components/spinner';
import { FacturaTasasConexosPago } from './modalFacturaTasasConexosPago';


function PagosRegistros3(props) {

    const [selectedID, setSelectedID] = useState(null);
    const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    const anioActu = JSON.parse(localStorage.getItem('anioactu'));
    const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    const [idTipoIngreso, setIdtipoIngreso] = useState(null);
    const [idFactura, setIdFactura] = useState(null);
    const [numFactura, setNumFactura] = useState(null);
    const [itemSelect, setItemSelect] = useState(-1);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mostrar, setMostrar] = useState(false);
    const [mostrar2, setMostrar2] = useState(false);
    const [factorCambio, setFactorCambio] = useState(0)

    const [desde, setDesde] = useState(0);
    const [operacion, setOperacion] = useState(1);

    const [activate, setActivate] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(true);
    const [btnDisabledE, setBtnDisabledE] = useState(false);
    const [factuPago, setFactuPago] = useState([]);
    const [deuda, setDeuda] = useState([]);
    const [verificacion, setVerificacion] = useState([]);
    const [totalSelect, setTotalSelect] = useState({
        montoseleccionado: '0,00',
        acrediSelect: '0,00',
        montoFacturadoSelect: '0,00',
        interesesSelect: '0,00',
        multaSelect: '0,00',
        recargoSelect: '0,00',
        retenSelect: '0,00'
    });

    const [values, setValues] = useState({
        concepto: '',
        seleccionados: 0,
        credito: '0,00',
        total: '0,00'
    });
    const [totPagar, setTotPagar] = useState('0,00');
    const [totPagado, setTotPagado] = useState('0,00');
    const [totPorPagar, setTotPorPagar] = useState('0,00');
    const [concepto, setConcepto] = useState('');
    const [datosFac, setDatosFac] = useState();
    const [facturaDet, setFacturaDet] = useState();


    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');

    const headCells = [
        { label: 'Código', textAlign: 'center' },
        { label: 'Nombre/Razón Social', textAlign: 'center' },
        /*    { label: 'Tipo de Impuesto', textAlign: 'center' }, */
        { label: 'Intereses', textAlign: 'center' },
        { label: 'Recargos', textAlign: 'center' },
        { label: 'Multa', textAlign: 'center' },
        { label: 'Total Factura', textAlign: 'center' },
        { label: 'Estatus', textAlign: 'center' }
    ]

    useEffect(() => {

        if (props.facturas) {
            setFactuPago(props.facturas);
            let total = 0.00;
            let totalP = 0.00;
            let totalxP = 0.00;
            for (let i = 0; i < props.facturas.length; i++) {
                /*total = parseFloat(total) + parseFloat(props.facturas[i].totalinmpuesto) + parseFloat(props.facturas[i].totalrecargo)
                        + parseFloat(props.facturas[i].totalinteres) + parseFloat(props.facturas[i].totalmulta) - parseFloat(props.facturas[i].deducible);*/

                total = parseFloat(total) + parseFloat(props.facturas[i].totalfactura);
                if (props.facturas[i].status === 1) {
                    totalP = parseFloat(totalP) + parseFloat(props.facturas[i].totalfactura);
                }
            }
            totalxP = parseFloat(total) - parseFloat(totalP);
            if (total > 0) {
                setSelectedID(0);
                //setBtnDisabled(false);
                setConcepto(props.facturas[0].descripcion);
                setItemSelect(0);
                setBtnDisabledE(true);
            } else {
                setSelectedID(null);
                //setBtnDisabled(true);
                setConcepto('');
                setBtnDisabledE(false);
            }
            setTotPagar(formatMoneda(total.toString().replace('.', ','), ',', '.', 2));
            setTotPagado(formatMoneda(totalP.toString().replace('.', ','), ',', '.', 2));
            setTotPorPagar(formatMoneda(totalxP.toString().replace('.', ','), ',', '.', 2));

            if (props.facturas.length > 0) {
                setBtnDisabled(false);
            } else {
                setBtnDisabled(true);
            }

        } else {
            setBtnDisabledE(false);
        }

        setFactorCambio(props.factorCambio)

    }, [props.facturas]);

    /*useEffect(() => {
        let total = 0.00;
        let totalP = 0.00;
        let totalxP = 0.00;
        for (let i = 0; i < factuPago.length; i++) {
            total = parseFloat(total) + parseFloat(factuPago[i].totalfactura);
            if (props.facturas[i].status === 1){
                totalP = parseFloat(totalP) + parseFloat(props.facturas[i].totalfactura);
            }
        }
        totalxP = parseFloat(total) - parseFloat(totalP);
        if (total > 0) {
            setSelectedID(0);
            setBtnDisabled(false);
            setConcepto(props.facturas[0].descripcion);
            setItemSelect(0);
            setBtnDisabledE(true);
        } else {
            setSelectedID(null);
            setBtnDisabled(true);
            setConcepto('');
            setBtnDisabledE(false);
        }
        setTotPagar(formatMoneda(total.toString().replace('.', ','), ',', '.', 2));
        setTotPagado(formatMoneda(totalP.toString().replace('.', ','), ',', '.', 2));
        setTotPorPagar(formatMoneda(totalxP.toString().replace('.', ','), ',', '.', 2));
    }, [factuPago]);*/

    const {
        TblContainer,
        TblHead
    } = useTableScroll(headCells);


    const cargarPagos = () => (e) => {
        e.preventDefault();
        if (factuPago[selectedID].status === 1) {
            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'La factura ya fue procesada.', icono: 'informacion' });
        } else {
            if (factuPago.length > 0) {
                setIdtipoIngreso(factuPago[selectedID].idtipoingreso);
                setIdFactura(factuPago[selectedID].idfactura);
                setNumFactura(factuPago[selectedID].numfactura);
                setDatosFac(factuPago[selectedID]);
                setVerificacion([]);
                setFacturaDet();
                if (factuPago[selectedID].idcontribuyente === "0" || factuPago[selectedID].idcontribuyente === null || factuPago[selectedID].tabladeuda === '' || factuPago[selectedID].tabladeuda === null) {
                    setMostrar2(true);
                } else {
                    seleccionarDetalleFactura(factuPago[selectedID].tabladeuda.trim());
                }
            }
        }

    }

    const cargarTasasConexos = () => (e) => {
        e.preventDefault();
        setMostrar(true);
    }

    const procesarEliminar = () => (e) => {
        e.preventDefault();
        let msg = '';
        if (factuPago[selectedID].status === 1) {
            msg = 'No se puede eliminar la factura ya fue procesada.';
            setMensaje({ mostrar: true, titulo: 'Notificacion', texto: msg, icono: 'informacion' });
        } else if (factuPago[selectedID].status === 0) {
            setDesde(0);
            msg = 'Esta Seguro de Eliminar el Registro?.';
            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });
        }

    }

    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        setActivate(true);
        eliminarFactura();

    };

    const eliminarFactura = () => {
        /*setIdtipoIngreso(deuda[selectedID].idtipoingreso);
        setIdFactura(deuda[selectedID].idfactura);
        setNumFactura(deuda[selectedID].numfactura);*/

        let endpoint = `${op.conexion}/api/Caja_Ingreso/eliminarfactura/${factuPago[selectedID].idfactura}`;

        axios.post(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                setActivate(false);
                props.onHideElimina(operacion);
            }

        }).catch(function (error) {

            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    };

    const procesarNumeroAtencion = () => {
        setActivate(true);
        let body = ({
            operacion: operacion,
            natencion: props.numatencion,
            fecha: fechaSistema,
            idusuario: idusuario,
            tipo: props.tipo,
            facturas: JSON.stringify(factuPago)
        });

        let endpoint = `${op.conexion}/api/Caja_Ingreso/actualizarnumeroatencion`;

        axios.post(endpoint, body, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                setActivate(false);
                setBtnDisabledE(false);
                seleccionarFacturas();
                props.onHideCancela();
                setMensaje({ mostrar: true, titulo: 'Notificacion', texto: 'El número de atención: ' + response.data[0].numatencion + ' fué generado', icono: 'informacion' });
            }

        }).catch(function (error) {

            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });
    };

    const seleccionarFacturas = () => {
        //window.location.href='/cajaingresos';
        //props.onHideRenderizar();
        let campos = '*';
        let nomtab = 'factura';
        let fe = "'" + moment.utc(fechaSistema).format('YYYY-MM-DD') + "'";
        let sta = 0;
        let condi = `facturador = ${idusuario} AND fechaemision = ${fe} AND status = ${sta}
                AND idfactura NOT IN (SELECT idfactura FROM ordenatenciondetalle WHERE fecha = ${fe})`;
        /*if (props.tipo === 1) {
            condi = `facturador = ${idusuario} AND fechaemision = ${fe} AND status = ${sta}`;
        } else {
            let letra = "'V'";
            condi = ` substring(numfactura, 1, 1) = ${letra} AND status = ${sta}`;
        }*/

        let orden = '1';
        let endpoint = `${op.conexion}/api/consulta/selecionarregistrocondi?campos=${campos}&nomtab=${nomtab}&condi=${condi}&orden=${orden}`;
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                console.log(response.data)

                if (response.data.length > 0) {
                    let total = 0.00;
                    let totalP = 0.00;
                    let totalxP = 0.00;
                    for (let i = 0; i < response.data.length; i++) {
                        total = parseFloat(total) + parseFloat(response.data[i].totalinmpuesto) + parseFloat(response.data[i].totalrecargo)
                            + parseFloat(response.data[i].totalinteres) + parseFloat(response.data[i].totalmulta)
                            - parseFloat(response.data[i].deducible);
                        if (props.facturas[i].status === 1) {
                            totalP = total = parseFloat(total) + parseFloat(response.data[i].totalinmpuesto) + parseFloat(response.data[i].totalrecargo)
                                + parseFloat(response.data[i].totalinteres) + parseFloat(response.data[i].totalmulta)
                                - parseFloat(response.data[i].deducible);
                        }
                    }
                    totalxP = parseFloat(total) - parseFloat(totalP);
                    if (total > 0) {
                        setSelectedID(0);
                        setBtnDisabled(false);
                        setConcepto(response.data[0].descripcion);
                        setItemSelect(0);
                    } else {
                        setSelectedID(null);
                        setBtnDisabled(true);
                        setConcepto('');
                    }
                    setTotPagar(formatMoneda(total.toString().replace('.', ','), ',', '.', 2));
                    setTotPagado(formatMoneda(totalP.toString().replace('.', ','), ',', '.', 2));
                    setTotPorPagar(formatMoneda(totalxP.toString().replace('.', ','), ',', '.', 2));
                    let fact = [];
                    //setFacturas(response.data);
                    for (let i = 0; i < response.data.length; i++) {
                        fact.push({
                            idfactura: response.data[i].idfactura,
                            numfactura: response.data[i].numfactura,
                            idcontribuyente: response.data[i].idcontribuyente,
                            totalinmpuesto: response.data[i].totalinmpuesto,
                            totalrecargo: response.data[i].totalrecargo,
                            totalinteres: response.data[i].totalinteres,
                            idtipoingreso: response.data[i].idtipoingreso,
                            fechaemision: response.data[i].fechaemision,
                            descripcion: response.data[i].descripcion,
                            tablacontribuyente: response.data[i].tablacontribuyente,
                            tabladeuda: response.data[i].tabladeuda,
                            iddeuda: response.data[i].iddeuda,
                            status: response.data[i].status,
                            nombrecontri: response.data[i].nombrecontri,
                            direccioncontri: response.data[i].direccioncontri,
                            cedrif: response.data[i].cedrif,
                            totalmulta: response.data[i].totalmulta === null ? "0.00" : response.data[i].totalmulta,
                            deducible: response.data[i].deducible,
                            facturador: response.data[i].facturador,
                            totalfactura: parseFloat(response.data[i].totalinmpuesto) + parseFloat(response.data[i].totalrecargo) + parseFloat(response.data[i].totalinteres)
                                + parseFloat(response.data[i].totalmulta === null ? "0.00" : response.data[i].totalmulta) - parseFloat(response.data[i].deducible),
                            idcomercio: response.data[i].idcomercio,
                            tipodeuda: response.data[i].tipodeuda,
                            idtasasweb: response.data[i].idtasasweb
                        })
                    }
                    setFactuPago(fact);
                    //setFactuPago(response.data);
                } else {
                    setFactuPago([]);
                    setTotPagar('0,00');
                    setTotPagado('0,00');
                    setTotPorPagar('0,00');
                }



            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(function () {
            setActivate(false);
        });
    };

    const seleccionarDetalleFactura = (nomtabladeu) => {
        setActivate(true);
        let campos = '*';
        let nomtab = 'facturadetalle';
        let nomid = 'idfactura';
        let valor = factuPago[selectedID].idfactura;
        let orden = 'idfacturadetalle';
        let endpoint = `${op.conexion}/api/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${valor}&orden=${orden}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                setFacturaDet(response.data);
                switch (nomtabladeu) {
                    case 'deudacomercio':
                        SelectDeudaC(factuPago[selectedID].idcontribuyente, response.data);
                        break;
                    case 'multa':
                        setActivate(false);
                        setMostrar2(true);
                        break;
                    case 'publicidad':
                    case 'licores':
                        setActivate(false);
                        setMostrar2(true);
                        break;
                    case '1x500':

                        break;
                    case 'expendedores':

                        break;
                    case 'rentas':

                        break;

                    default:
                        SelectDeuda(factuPago[selectedID].idcontribuyente, response.data, nomtabladeu);
                    //setActivate(false);
                }

                //setMostrar2(true);

            }
            //setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })/* .finally(function () {
            setActivate(false);
        }) */;
    };

    const SelectDeudaC = (id, facdet) => {

        setActivate(true);

        let endpoint;
        if (espiritu === 0) {
            endpoint = `${op.conexion}/api/industria/deudacomerciors?idcomercio=${id}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=${1}`;
        } else {
            endpoint = `${op.conexion}/api/industria/deudacomercio?idcomercio=${id}&fecha=${fechaSistema}&espiritu=${espiritu}&tipounid=${1}`;
        }
        //let endpoint = `${op.conexion}/api/minas/deudas?idagente=${id}&fecha=${fechaSistema}&tabconf=${tab}&condic=${tipod}`;
        console.log(endpoint)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                let nummes = '';
                let anio = '';
                var deu = [];
                var totdeu = parseFloat(0.00);
                for (let i = 0; i < response.data.length; i++) {
                    for (let x = 0; x < facdet.length; x++) {
                        nummes = (facdet[x].periodo.trim().length === 7
                            ? facdet[x].periodo.substring(0, 2)
                            : facdet[x].periodo.substring(0, 3));
                        anio = facdet[x].periodo.trim().length === 7
                            ? facdet[x].periodo.substring(3, 7)
                            : facdet[x].periodo.substring(4, 8);
                        if (response.data[i].nmes === nummes &&
                            response.data[i].anio.toString() === anio.toString() &&
                            response.data[i].tipodeuda === facdet[x].tipodeuda) {
                            deu.push({
                                anio: response.data[i].anio, mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                monto: response.data[i].mondeu, intereses: response.data[i].intmoradeu,
                                recargo: response.data[i].recargodeu, multa: response.data[i].multa,
                                retenciones: response.data[i].retencion, credito: response.data[i].acreditacion,
                                totalperi: response.data[i].subtotal, status: response.data[i].estatus,
                                idfac: response.data[i].idfact, nummes: response.data[i].nmes,
                                estatusfac: response.data[i].estatusfac, tipotransaccion: response.data[i].tipotransaccion,
                                tipodeuda: response.data[i].tipodeuda, iddeudacomercio: response.data[i].iddeudacom,
                                nomdeuda: response.data[i].nomdeuda
                            });
                        }
                    }

                }

                setDeuda(deu);
                setMostrar2(true);
            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(function () {
            setActivate(false);
        })


    };

    const SelectDeuda = (id, facdet, nomtabladeu) => {

        setActivate(true);
        let endpoint = '';

        switch (nomtabladeu) {
            case 'deudainmueble':
                endpoint = `${op.conexion}/api/inmueble/deudainmueble?idinmueble=${id}&fecha=${fechaSistema}&espiritu=${espiritu}`;
                break;
            case 'deudavehiculo':
                endpoint = `${op.conexion}/api/vehiculo/deudavehiculo?idvehiculo=${id}&fecha=${fechaSistema}&espiritu=${espiritu}`;
                break;
            case 'deudarentas':
                let tabla = 'aseo'
                let endpoint = '';
                if (espiritu === 0) {
                    endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${id}&fecha=${fechaSistema}&tabla=${tabla} `;
                } else {
                    endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${id}&fecha=${fechaSistema}&tabla=${tabla} `;
                }
                //endpoint = `${op.conexion}/api/aseo/deudarenta?idrentas=${id}&fecha=${fechaSistema}&tabla=${tabla}`;
                //endpoint = `${op.conexion}/api/aseo/deudarenta1?idrentas=${id}&fecha=${fechaSistema}&tabla=${tabla}`;
                break;
            case 'rentas':

                break;

            default:
                setActivate(false);
        }
        //let endpoint = `${op.conexion}/api/minas/deudas?idagente=${id}&fecha=${fechaSistema}&tabconf=${tab}&condic=${tipod}`;
        console.log(endpoint)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                let nummes = '';
                let anio = '';
                var deu = [];
                var totdeu = parseFloat(0.00);
                for (let i = 0; i < response.data.length; i++) {
                    for (let x = 0; x < facdet.length; x++) {
                        nummes = facdet[x].periodo.substring(0, 2);
                        anio = facdet[x].periodo.substring(3, 7);
                        if (response.data[i].nmes === nummes &&
                            response.data[i].anio.toString() === anio.toString()) {
                            switch (nomtabladeu) {
                                case 'deudainmueble':
                                    deu.push({
                                        anio: response.data[i].anio, mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                        monto: response.data[i].mondeu, intereses: response.data[i].intmoradeu,
                                        recargo: response.data[i].recargodeu, multa: "0.00",
                                        retenciones: "0.00", credito: "0.00",
                                        totalperi: response.data[i].subtotal, status: response.data[i].estatus,
                                        idfac: response.data[i].idfact, nummes: response.data[i].nmes,
                                        estatusfac: response.data[i].estatusfac, tipotransaccion: response.data[i].tipotransaccion,
                                        tipodeuda: response.data[i].tipodeuda, iddeudainmueble: response.data[i].iddeuda,
                                        nomdeuda: response.data[i].mes.replace("'", "").replace("'", "")
                                    });
                                    break;
                                case 'deudavehiculo':
                                    deu.push({
                                        anio: response.data[i].anio, mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                        monto: response.data[i].mondeu, intereses: response.data[i].intmoradeu,
                                        recargo: response.data[i].recargodeu, multa: "0.00",
                                        retenciones: "0.00", credito: "0.00",
                                        totalperi: response.data[i].subtotal, status: response.data[i].estatus,
                                        idfac: response.data[i].idfact, nummes: response.data[i].nmes,
                                        estatusfac: response.data[i].estatusfac, tipotransaccion: response.data[i].tipotransaccion,
                                        tipodeuda: response.data[i].tipodeuda, iddeudavehiculo: response.data[i].iddeuda,
                                        nomdeuda: response.data[i].mes.replace("'", "").replace("'", ""),
                                        nomdeuda: response.data[i].mes.replace("'", "").replace("'", "").toLowerCase()
                                    });
                                    break;
                                case 'deudarentas':
                                    deu.push({
                                        anio: response.data[i].anio, mes: response.data[i].mes.replace("'", "").replace("'", ""),
                                        monto: response.data[i].mondeu * factorCambio, intereses: response.data[i].intmoradeu * factorCambio,
                                        recargo: response.data[i].recargodeu * factorCambio, multa: "0.00",
                                        retenciones: "0.00", credito: "0.00",
                                        totalperi: response.data[i].subtotal, status: response.data[i].estatus,
                                        idfac: response.data[i].idfact, nummes: response.data[i].nmes,
                                        estatusfac: response.data[i].estatusfac, tipotransaccion: response.data[i].tipotransaccion,
                                        tipodeuda: response.data[i].tipodeuda, iddeudarentas: response.data[i].iddeuda
                                    });
                                    break;
                                case 'rentas':

                                    break;

                                default:
                                    setActivate(false);
                            }

                        }
                    }

                }

                setDeuda(deu);
                setMostrar2(true);
            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(function () {
            setActivate(false);
        })


    };

    const seleccionarVerificacion = () => {
        setActivate(true);
        /*let campos = '*';
        let nomtab = 'verificacion';
        let nomid = 'idverificacion';
        let valor = parseInt(factuPago[selectedID].numfactura.substring(1));
        let orden = 'idverificacion';
        let endpoint = `${op.conexion}/api/consulta/modelirows?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${valor}&orden=${orden}`;*/
        let endpoint = `${op.conexion}/api/Caja_Ingreso/selectverificacionbyid?idverificacion=${parseInt(factuPago[selectedID].numfactura.substring(1))}`;
        console.log(endpoint)
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                setVerificacion(response.data);
                //SelectDeuda(factuPago[selectedID].idcontribuyente, response.data);
                setMostrar2(true);

            }
            setActivate(false);

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(function () {
            setActivate(false);
        });
    };

    const handleAceptaFacturaConexos = () => {
        setMostrar(false);
        seleccionarFacturas();

    }

    const editar = (e) => {
        e.preventDefault();
        setOperacion(2);
        props.onHideEdita();
        setBtnDisabledE(true);

    }

    const cancelar = (e) => {
        e.preventDefault();
        setOperacion(1);
        props.onHideCancela();
        setBtnDisabledE(false);
    }

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;

        if (factuPago.length > 0) {
            setDesde(1)
            let msg = 'Esta seguro de Procesar?.';
            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: msg, icono: 'confirmacion' });

        }
    };

    const seleccionarNumAtencion = () => {
        let numaten = props.numaten;
        let fe = "'" + moment.utc(fechaSistema).format('YYYY-MM-DD') + "'";
        let llamado = '1';
        let endpoint = `${op.conexion}/api/Caja_Ingreso/seleccionarnumeroatencion?numaten=${numaten}&fecha=${fe}&idusuario=${idusuario}&llamado=${llamado}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            }
        }).then(function (response) {

            if (response.status === 200) {
                let fact = [];
                //setFacturas(response.data);
                for (let i = 0; i < response.data.length; i++) {
                    fact.push({
                        idfactura: response.data[i].idfactura,
                        numfactura: response.data[i].numfactura,
                        idcontribuyente: response.data[i].idcontribuyente,
                        totalinmpuesto: response.data[i].totalinmpuesto,
                        totalrecargo: response.data[i].totalrecargo,
                        totalinteres: response.data[i].totalinteres,
                        idtipoingreso: response.data[i].idtipoingreso,
                        fechaemision: response.data[i].fechaemision,
                        descripcion: response.data[i].descripcion,
                        tablacontribuyente: response.data[i].tablacontribuyente,
                        tabladeuda: response.data[i].tabladeuda,
                        iddeuda: response.data[i].iddeuda,
                        status: response.data[i].status,
                        nombrecontri: response.data[i].nombrecontri,
                        direccioncontri: response.data[i].direccioncontri,
                        cedrif: response.data[i].cedrif,
                        totalmulta: response.data[i].totalmulta === null ? "0.00" : response.data[i].totalmulta,
                        deducible: response.data[i].deducible,
                        facturador: response.data[i].facturador,
                        totalfactura: parseFloat(response.data[i].totalinmpuesto) + parseFloat(response.data[i].totalrecargo) + parseFloat(response.data[i].totalinteres)
                            + parseFloat(response.data[i].totalmulta === null ? "0.00" : response.data[i].totalmulta) - parseFloat(response.data[i].deducible),
                        idcomercio: response.data[i].idcomercio,
                        tipodeuda: response.data[i].tipodeuda

                    })
                }
                setFactuPago(fact);
            }
            setActivate(false);

        }).catch(function (error) {
            console.log(error)

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(function () {
            setActivate(false);
        });
    };

    return (
        <div className="mx-auto px-0">
            <RegistrarPago
                show={mostrar2}
                tipo={idTipoIngreso}
                fecha={fechaSistema}
                idfactura={idFactura}
                numfactura={numFactura}
                factura={datosFac}
                facturadet={facturaDet}
                deuda={deuda}
                tasa={factorCambio}
                verificacion={verificacion}
                onHideRenderizar={seleccionarNumAtencion}
                onHideCancelar={() => {
                    setMostrar2(false);
                    /*props.onHideRenderizar();*/
                    setDeuda([]);
                    //setFacturaDet([]);
                    //setDatosFac([]);
                }}

            />
            <FacturaTasasConexosPago
                show={mostrar}
                tipo={idTipoIngreso}
                onHideAcepta={handleAceptaFacturaConexos}
                onHideCancela={() => {
                    setMostrar(false);
                }}

            />

            <div className="col-md-12 bg-light rounded">
                <div className="row py-2 mx-auto px-0 col-md-12">
                    <div className="bg-light col-md-10 col-12 px-0 row">

                        <Mensaje mensaje={mensaje}
                            onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                        <MensajeSiNo mensaje={mensajesino}
                            onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
                        <div id='declaraciones'>
                            <TblContainer container={{ height: 280, maxHeight: 380, width: '100%', overflow: 'auto' }}>
                                <TblHead />
                                <tbody className='table-bordered'>
                                    {factuPago && factuPago.map((deu, index) => (

                                        <tr key={index}
                                            onClick={() => {
                                                setSelectedID(index);
                                                setConcepto(factuPago[index].descripcion)
                                                setItemSelect(index);
                                            }}
                                            style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }}
                                        >
                                            <td className='p-0 text-center'>{deu.idcontribuyente > 0 ? deu.idcontribuyente : ""}</td>
                                            <td className='p-0 text-left'>{deu.nombrecontri.trim() + '(' + deu.numfactura + ')'}</td>
                                            {/*  <td className='p-0 text-center'>{deu.tablacontribuyente.trim()}</td> */}
                                            {/* <td className='p-0'>{formatMoneda(deu.totalinmpuesto.replace(',', '').replace('.', ','), ',', '.', 2)}</td> */}
                                            <td className='p-0 text-right'>{formatMoneda(deu.totalinteres.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                            <td className='p-0 text-right'>{formatMoneda(deu.totalrecargo.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                            <td className='p-0 text-right'>{formatMoneda(deu.totalmulta.replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                            {/* <td className='p-0'>{formatMoneda(deu.deducible.replace(',', '').replace('.', ','), ',', '.', 2)}</td> */}
                                            <td className='p-0 text-right'>{formatMoneda(deu.totalfactura.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                            <td className='p-0 text-center'>{deu.status === 0 ? 'Por Procesar' : 'Procesada'}</td>
                                        </tr>

                                    ))}
                                </tbody>
                            </TblContainer>
                            <div className='row col-12 p-0 m-0 border-table' style={{ borderTopStyle: 'hidden' }}>
                                <div className='col-md-10'>
                                    <div className="input-group input-group-sm">
                                        <label className="fw-bold" id="inputGroup-sizing-sm">Detalle de la Factura:</label>
                                        <p className='px-2 mt-1'>{concepto}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row col-md-4 p-0 ml-3 border-table' style={{ borderTopStyle: 'hidden' }}>


                            <table>
                                <tbody>
                                    <tr className='py-0'>
                                        <td className='text-right mr-auto my-auto py-0 border-0'><label className='fw-bold'>Total a Pagar: {totPagar}</label></td>
                                    </tr>
                                    <tr className='py-0'>
                                        <td className='text-right mr-auto my-auto py-0 border-0'><label className='fw-bold'>Total Pagado: {totPagado}</label></td>
                                    </tr>
                                    <tr className='py-0'>
                                        <td className='text-right mr-auto my-auto py-0 border-0'><label className='fw-bold'>Total por Pagar: {totPorPagar}</label></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className='col-md-8 row mx-auto'>
                            <div className='col-md-5'></div>
                            {/*                             <button className=' my-auto btn btn-sm btn-warning rounded-pill col-md-2' disabled={btnDisabledE} onClick={editar} ><i className="fa fa-edit">Editar</i></button>
                            <button className=" my-auto btn btn-sm btn-success rounded-pill col-md-2" disabled={btnDisabledE} onClick={onChangeValidar} ><i className='fas fa-check-circle'>  Aceptar</i></button> */}
                            <button className=" my-auto ml-auto btn btn-sm btn-danger rounded-pill col-md-3" /*disabled={btnDisabledE}*/ onClick={cancelar} ><i className='fas fa-window-close'>  Cancelar</i></button>
                        </div>

                    </div>

                    <div className='col-md-2 px-0 py-2 m-auto'>

                        <button disabled={btnDisabled} onClick={cargarPagos()} className="btn btn-sm rounded-pill btn-success col-8 ml-5" ><i className="fas fa-share"> Registrar Pago</i></button>
                        <div className='col-12 py-1'></div>
                        <button disabled={btnDisabled} onClick={procesarEliminar()} className="btn btn-sm rounded-pill btn-danger col-8 ml-5" ><i className="fa fa-trash"> Eliminar Pago</i></button>

                    </div>
                </div>
            </div>
        </div >
    );
}

export default PagosRegistros3;
